module.exports = {
    methods: {
        show(zIndex) {
            if (document.getElementsByClassName('app-overlay').length > 0) {
                document.getElementsByClassName('app-overlay')[0].style.display = 'block';
                if (zIndex)
                    document.getElementsByClassName('app-overlay')[0].style.zIndex = zIndex;
            }
        },

        hide() {
            for (var i = 0; i < document.getElementsByClassName('app-overlay').length; i++) {
                document.getElementsByClassName('app-overlay')[i].style.display = '';
                document.getElementsByClassName('app-overlay')[i].style.zIndex = null;
            }
        },

        fullTopUrl: function () {            
            let origin = new URL(document.referrer).href;
            let index = origin.toLowerCase().indexOf('/login');
            origin = origin.substring(0, index);            
            return origin;            
        },

        fullLocationUrl: function () {           
            let subDirectories = new URL(location.href).pathname.split('/');
            let subDirectory = subDirectories.length >= 2 && subDirectories[1].trim() != '' ?
                `/${subDirectories[1]}` : '';
            let origin = new URL(location.href).origin + subDirectory;
            return origin;
        },

        subDirectory: function () {
            let subDirectories = new URL(location.href).pathname.split('/');
            return subDirectories.length >= 2 && subDirectories[1].trim() != '' ?
                `${subDirectories[1]}` : '';
        },

        fullTopUrlWithoutAppCode: function () {
            let origin = window.location.href.replace('/Applications/Login', '');                        
            return origin;            
        },

        getAppCode: function () {            
            let subDirectories = new URL(document.referrer).pathname.split('/');
            let subDirectoriesFiltered = subDirectories.filter(function (item) {
                return item.includes("app-")
            });
            return subDirectoriesFiltered.length > 0 ? subDirectoriesFiltered[0] : "";
        },

        showAlert: function(message,type, lowercase = true){
            this.$store.commit("CHANGE_ALERT_MESSAGE", lowercase ? message.toLowerCase() : message);
            this.$store.commit("CHANGE_ALERT_TYPE",type);
            this.$store.commit("CHANGE_ALERT_SHOW", true);            
            this.isLoading = false;
        },        

        isAppMobile: function(){
            let appCookie = this.$cookie.get("OrquestraBpmsApp");                
            return (appCookie || (document.getElementById("iframe-main") && document.getElementById("iframe-main").src.indexOf("mobileApp") > 0))                
        },

        isRenderMobile : function(){
            if (navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)
            ) {
                return true;
            }
            else {
                return false;
            }
        },

        addElementToHead: function (elementType) {
            var element = document.createElement(elementType);
            document.head.appendChild(element);

            return element;
        },

        addElementToBody: function (elementType, elementInnerHTML) {
            var element = document.createElement(elementType);
            if (elementInnerHTML)
                element.innerHTML = elementInnerHTML;
            document.body.appendChild(element);

            return element;
        }
    }
}